import request from '@/utils/request'

// User List
export function getUserList(param) {
  let data = param
  return request({
    url: `/zdmin/epmsZ030/getUserList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// User Password Initialize
export function passwordInitialize(param) {
  let data = param
  return request({
    url: `/zdmin/epmsZ030/passwordInitialize`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// Change Use Disable
export function updateDisable(param) {
  let data = param
  return request({
    url: `/zdmin/epmsZ030/updateDisable`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// Change Use Enable
export function updateEnable(param) {
  let data = param
  return request({
    url: `/zdmin/epmsZ030/updateEnable`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// create New Id
export function createNewId(param) {
  let data = param
  return request({
    url: `/zdmin/epmsZ030/createNewId`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}